import React, { useState } from 'react';
export function FAQSection() {
  const faqs = [{
    q: 'Is this a digital product?',
    a: "Yes. You'll get instant digital access after purchase."
  }, {
    q: 'Do I need a professional camera?',
    a: 'No. This MegaPack was designed specifically for people using their phone.'
  }, {
    q: 'Is this beginner-friendly?',
    a: 'Yes. Everything is explained in a simple, practical way without heavy technical language.'
  }, {
    q: 'Will this work if my dog never sits still?',
    a: 'Yes. The MegaPack includes calm portraits, everyday moments, playful photos, and action shots.'
  }, {
    q: 'Do I need Lightroom?',
    a: 'No. The main MegaPack works perfectly without it. Lightroom is included only as an extra bonus for people who want more polished edits.'
  }, {
    q: 'Can I use this for both indoor and outdoor photos?',
    a: 'Yes. The system covers both.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream py-20 px-4" data-id="element-59">
      <div className="max-w-3xl mx-auto" data-id="element-60">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-center text-black mb-12" data-id="element-61">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-62">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-63">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-64">
                <span className="font-sans font-bold text-lg text-black pr-8" data-id="element-65">
                  {faq.q}
                </span>
                <span className={`text-orange text-2xl transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`} data-id="element-66">
                  +
                </span>
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-67">
                <p className="font-sans text-gray-700 leading-relaxed" data-id="element-68">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}